<script>
  export let down = false
</script>

<svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
  {#if down}
    <path d="M1 0.999999L5 5L9 1" stroke="black"/>
  {:else}
    <path d="M9 5L5 1L1 5" stroke="black"/>
  {/if}
</svg>

<style lang="scss">
  svg {
    transform: translateY(-0.32em) scale(1.2);
    bottom: 0.35em;
    stroke-width: 0.15ex;
    padding: 0 0.15em 0 0.2em;
  }
</style>